import { render, staticRenderFns } from "./DashboardImagePreview.vue?vue&type=template&id=b6bc104a&scoped=true"
import script from "./DashboardImagePreview.vue?vue&type=script&lang=js"
export * from "./DashboardImagePreview.vue?vue&type=script&lang=js"
import style0 from "./DashboardImagePreview.vue?vue&type=style&index=0&id=b6bc104a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bc104a",
  null
  
)

export default component.exports